import React from 'react'
import TravelCard from '../../components/travelCard'
import { Pagination } from '../../components/Pagination'

const CardsSection = ({ data, page, setPage, setPagination, showSaved }) => {
    const packingCards = data && data?.data
    const bymtach = data && data?.bymtach
    const totalPages = data && data?.pagination?.totalPages
    const handleChange = (value) => {
        setPage(value); setPagination(value + 1)
    }
    return (
        <div className="">
            <div className="grid md:grid-cols-3 grid-cols-1 gap-4 max-w-[1250px] mx-auto my-12 px-4">
                <div className="">
                    <h2 className='text-dark italic font-roboto-mono text-xl capitalize font-bold' >perfect match</h2>
                    <p className='text-dark font-quicksand text-sm font-medium' >
                        Below find the perfect match for your search, if we did not fond you a perfect match check under “Almost a Match”
                    </p>
                </div>
            </div>
            {packingCards?.length > 0 ?
                <>


                    <div className='grid md:grid-cols-3 grid-cols-1  gap-8 p-4 max-w-[1250px] mx-auto my-12' >
                        {packingCards?.map((item, index) => {
                            return (
                                <TravelCard item={item} proCard={item?.type == 'PRO' ? true : false} />
                            )
                        })}

                    </div>
                    {/* <div className="my-5">
                        <Pagination currentPage={page} totalPages={totalPages} onPageChange={handleChange} />
                    </div> */}

                </>

                :
                <>
                    <h2 className='text-dark italic text-center font-roboto-mono text-xl capitalize font-bold' > {showSaved ? 'No saved packing lists found' : 'No packing lists found'} </h2>
                </>

            }
            <div className="grid md:grid-cols-3 grid-cols-1 gap-4 max-w-[1250px] mx-auto my-12 px-4">
                <div className="">
                    <h2 className='text-dark italic font-roboto-mono text-xl capitalize font-bold' >it’s almost a match</h2>
                    <p className='text-dark font-quicksand text-sm font-medium' >
                        If there is not perfect macth for your search check out similar packing lists.
                    </p>
                </div>
            </div>
            {bymtach?.length > 0 ?
                <>


                    <div className='grid md:grid-cols-3 grid-cols-1  gap-8 p-4 max-w-[1250px] mx-auto my-12' >
                        {bymtach?.map((item, index) => {
                            return (
                                <TravelCard item={item} proCard={item?.type == 'PRO' ? true : false} />
                            )
                        })}

                    </div>
                    {/* <div className="my-5">
                        <Pagination currentPage={page} totalPages={totalPages} onPageChange={handleChange} />
                    </div> */}

                </>

                :
                <>
                    <h2 className='text-dark italic font-roboto-mono text-center my-7 text-xl capitalize font-bold' > {showSaved ? 'No saved packing lists found' : 'No packing lists found'} </h2>
                </>

            }


        </div>

    )
}

export default CardsSection
